export default "__VITE_ASSET__DWq6Y2R$__"